module.exports = __webpack_public_path__ + "media/images/favicons/icon-160x160-8e3b141ef655108e40e56f305fe6b27e.png";